import axios from '../utils/axios';
import { Gate, DuplicateAnalysis, MergeResult, CleanupResult } from '../types/Gate';

export async function getGates(queryString: string = ''): Promise<Gate[]> {
  const suffix = queryString ? `?${queryString}` : '';
  return axios.get(`/gates${suffix}`).then((res) => res?.data ?? []);
}

export async function updateGate(gateId: string, data: Partial<Gate>): Promise<Gate> {
  return axios.put(`/gates/${gateId}`, data).then((res) => res.data);
}

export async function deleteGate(gateId: string): Promise<any> {
  return axios.delete(`/gates/${gateId}`).then((res) => res.data);
}

export async function createGate(data: Partial<Gate>): Promise<Gate> {
  return axios.post('/gates', data).then((res) => res.data);
}

export async function deleteGates(gateIds: string[]): Promise<any> {
  // Batch delete multiple gates
  return Promise.all(gateIds.map((id) => deleteGate(id)));
}

export async function getGateDuplicateAnalysis(): Promise<DuplicateAnalysis> {
  return axios.get('/gates?scope=duplicate_analysis').then((res) => res?.data ?? { duplicate_groups: [], summary: {} });
}

export async function mergeGates(gateIds: string[]): Promise<MergeResult> {
  return axios.post('/gates/merge', { gate_ids: gateIds }).then((res) => res.data);
}

export async function cleanupOrphanGates(): Promise<CleanupResult> {
  return axios.post('/gates/cleanup-orphans', {}).then((res) => res.data);
}
